/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Asset } from './asset';
import { SettlementDestinationDto } from './settlementDestinationDto';

export interface TransferDto {
  id?: number;
  accountId?: number;
  account?: Account;
  assetId?: number;
  asset?: Asset;
  direction?: TransferDto.DirectionEnum;
  requestedQuantity?: number;
  quantity?: number;
  allowReduceQuantityTo?: number;
  createTime?: string;
  settleTime?: string;
  status?: TransferDto.StatusEnum;
  systemNote?: string;
  adminNote?: string;
  clientNote?: string;
  transferSource?: TransferDto.TransferSourceEnum;
  txHash?: string;
  needManualAction?: boolean;
  networkFee?: number;
  networkFeeAssetName?: string;
  networkFeeInUsd?: number;
  exchangeWithdrawalFee?: number;
  settlementDestinationId?: number;
  fromAddress?: string;
  toAddress?: string;
  exchangeWithdrawalFeeUsdNotional?: number;
  businessEntity?: TransferDto.BusinessEntityEnum;
  linkedAccountId?: number;
  linkedTransferId?: number;
  destinationDto?: SettlementDestinationDto;
  jurisdiction?: string;
  address?: string;
}
export namespace TransferDto {
  export const DirectionEnum = {
    Deposit: 'DEPOSIT',
    Withdraw: 'WITHDRAW',
    Internal: 'INTERNAL',
    DepositRebate: 'DEPOSIT_REBATE',
    WithdrawRebate: 'WITHDRAW_REBATE',
    InternalDeposit: 'INTERNAL_DEPOSIT',
    InternalWithdraw: 'INTERNAL_WITHDRAW',
  } as const;
  export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];
  export const StatusEnum = {
    Pending: 'PENDING',
    Error: 'ERROR',
    Settled: 'SETTLED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const TransferSourceEnum = {
    Manual: 'MANUAL',
    Fireblocks: 'FIREBLOCKS',
    Golden: 'GOLDEN',
    ExchangeToExchange: 'EXCHANGE_TO_EXCHANGE',
    HrpSettlement: 'HRP_SETTLEMENT',
    SubAccount: 'SUB_ACCOUNT',
  } as const;
  export type TransferSourceEnum = (typeof TransferSourceEnum)[keyof typeof TransferSourceEnum];
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
